import { render, staticRenderFns } from "./download_overlay.vue?vue&type=template&id=21c436e3&scoped=true&"
import script from "./download_overlay.vue?vue&type=script&lang=js&"
export * from "./download_overlay.vue?vue&type=script&lang=js&"
import style0 from "./download_overlay.vue?vue&type=style&index=0&id=21c436e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c436e3",
  null
  
)

export default component.exports